import {useEffect, useMemo, useRef, useState} from "preact/compat";

function youtubeParser(url){
    if (!url) {
        return "";
    }

    let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    let match = url.match(regExp);

    return (match && match[7].length === 11) ? match[7] : false;
}

export const useSecondSlide = (props) => {
    // Destructured props
    const {
        currentSlide,
        selfServiceAttendanceModalData,
    } = props;

    // State to control the video embed feature
    const [isUnlocked, setIsUnlocked] = useState(false);

    // Self-explanatory
    const videoRef = useRef(null);

    // We're keeping this inside a useMemo in case we need to switch back to the YouTube embed approach
    const videoUrl = useMemo(() => {
        // return youtubeParser(selfServiceAttendanceModalData?.urlVideo || "");
        return selfServiceAttendanceModalData?.urlVideo || "";
    }, [selfServiceAttendanceModalData]);

    // Procedure to handle the "isUnlocked" state
    const handleIsUnlocked = () => {
        setIsUnlocked(prevState => !prevState);
    }

    // Effect to lock the video player when the slide changes
    useEffect(() => {
        if (currentSlide !== 2) {
            // Pauses the video whenever a slide changes
            videoRef.current?.pause();
        }
    }, [currentSlide]);

    return {
        isUnlocked,
        videoRef,
        videoUrl,
        handleIsUnlocked,
    }
}
